__turbopack_context__.v({
  "region": "DescriptionBlocks-module__wfHE7a__region",
});
